import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'wouter'
import { InboxArrowDownIcon } from '@heroicons/react/24/outline'
import { messagesService } from '@/services/messagesService'
import { useUser } from '@/store/authStore'

const POLL_MS = 20000

export const MessagesButton = () => {
  const user = useUser()
  const [unread, setUnread] = useState(0)
  const [, navigate] = useLocation()

  const refresh = useCallback(async () => {
    try {
      const result = await messagesService.unreadCount()
      setUnread(result.unread)
    } catch {
      setUnread(0)
    }
  }, [])

  useEffect(() => {
    if (!user) return
    void refresh()
    const timer = setInterval(() => void refresh(), POLL_MS)
    return () => clearInterval(timer)
  }, [user, refresh])

  if (!user) return null

  return (
    <button
      type="button"
      onClick={() => navigate('/student/mesajlar')}
      aria-label="Mesajlar"
      className="relative p-2 rounded-full hover:bg-gray-100 transition-colors"
    >
      <InboxArrowDownIcon className="w-6 h-6 text-gray-600" />
      {unread > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-blue-600 text-white text-[10px] font-bold">
          {unread > 9 ? '9+' : unread}
        </span>
      )}
    </button>
  )
}
